import { MatchState, RoundState } from "@alienheadwars/football-card-manager-model"
import { Card, Stack } from "@mui/material"
import { useEffect, useState } from "react"
import { DIGITAL_FONTS } from "../../../../fonts/fonts"
import { CardDimensions } from "../../../../cards/playerCards/CardDimensions"
import { localise } from "../../../../../locale/locale";

export interface MatchClockProps {
    matchState: MatchState,
    dimensions: CardDimensions
}

export const MatchClock = (props: MatchClockProps) => {
    const latestRound = props.matchState.rounds[props.matchState.rounds.length - 1]
    return <RoundTimeComponent roundState={latestRound} live={!props.matchState.matchFinished} dimensions={props.dimensions} />
}


interface RoundTimeComponentProps {
    roundState: RoundState,
    live: boolean,
    dimensions: CardDimensions
}

const getMinutes = (round: RoundState) => {
    console.log(`(round.half ${round.half} === 0 ? 0 : 45) ${(round.half === 0 ? 0 : 45)} + Math.min(round.halfRoundId ${round.halfRoundId}, 10) * 5 ${Math.min(round.halfRoundId, 10) * 5}}`)
    return (round.half === 0 ? 0 : 45) + Math.min(round.halfRoundId, 9) * 5
}

const getStoppageMinutes = (round: RoundState) => {
    return isStoppageTime(round) ? round.halfRoundId - 9 : 0
}

const isStoppageTime = (round: RoundState) => {
    return round.halfRoundId >= 9
}


const RoundTimeComponent = (props: RoundTimeComponentProps) => {
    const [time, setTime] = useState({
        roundId: props.roundState.roundId,
        minutes: getMinutes(props.roundState),
        seconds: 0,
        startMinutes: getMinutes(props.roundState),
        //TODO set stoppage minutes and increment
        stoppageMinutes: getStoppageMinutes(props.roundState),
        stoppageSeconds: 0,
    })

    useEffect(() => {
        if ((props.roundState.roundId !== time.roundId)
            || !props.live
        ) {
            setTime({
                roundId: props.roundState.roundId,
                minutes: getMinutes(props.roundState),
                seconds: 0,
                startMinutes: getMinutes(props.roundState),
                stoppageMinutes: getStoppageMinutes(props.roundState),
                stoppageSeconds: 0,
            })
        }
        else {
            const intevalId = setInterval(() => {
                isStoppageTime(props.roundState) ?

                    //Stoppage time setting
                    setTime(currentTime => {
                        const newTime = { ...currentTime }
                        if (newTime.stoppageSeconds < 59) {
                            newTime.stoppageSeconds++
                        }
                        // Don't increment the minute, each round is a minute in staoppage time
                        // else {
                        //     newTime.stoppageSeconds = 0
                        //     newTime.stoppageMinutes++
                        // }
                        return newTime
                    })
                    :
                    //Regular time setting
                    setTime(currentTime => {

                        const newTime = { ...currentTime }
                        if (newTime.seconds < 59) {
                            newTime.seconds++
                        }
                        else if (newTime.minutes - newTime.startMinutes < 4) {
                            newTime.seconds = 0
                            newTime.minutes++
                        }
                        return newTime
                    })

            }, 1000)
            return () => {
                clearInterval(intevalId)
            }
        }
    }, [props.live, props.roundState, time.roundId])

    return <Card sx={{
        alignContent: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        justifyItems: 'center',
        display: 'flex',
        backgroundColor: 'black',
        padding: '1vmin',
    }}>
        {/* Half indicator */}
        <Stack>
            <Stack direction={'row'} spacing={1} sx={{
                alignContent: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                justifyItems: 'center',
                display: 'flex',
                color: 'yellow',
                backgroundColor: 'black',
                fontFamily: DIGITAL_FONTS,
                fontSize: props.dimensions.playerNameFontSize,
            }}>
                {localise(`match.half.${props.roundState.half}`)} half
            </Stack>
            {/* Main clock */}
            <Stack direction={'row'} spacing={1} sx={{
                alignContent: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                justifyItems: 'center',
                display: 'flex',
                color: 'red',
                backgroundColor: 'black',
                fontFamily: DIGITAL_FONTS,
                fontSize: props.dimensions.playerNameFontSize,
            }}>
                {String(time.minutes).padStart(2, '0')}:{String(time.seconds).padStart(2, '0')}
            </Stack>
            {/* Stoppage time */}
             <Stack direction={'row'} spacing={1} sx={{
                alignContent: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                justifyItems: 'center',
                display: 'flex',
                color: 'yellow',
                backgroundColor: 'black',
                fontFamily: DIGITAL_FONTS,
                fontSize: props.dimensions.playerNameFontSize,
                opacity: isStoppageTime(props.roundState) ? 1 : 0, //hide, but take space, if not stoppage time yet
            }}>
                +{String(time.stoppageMinutes)}:{String(time.stoppageSeconds).padStart(2, '0')}
            </Stack>
        </Stack>

    </Card>

}